export default __webpack_public_path__ + "static/media/FunkyVibes.37e52e55.ttf";